const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "profile",
  transform: "translate(-0.301)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  className: "cls-1",
  d: "M77.653,0A5.454,5.454,0,1,1,72.2,5.454,5.454,5.454,0,0,1,77.653,0Zm0,0",
  transform: "translate(-68.016)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_403",
  "data-name": "Path 403",
  className: "cls-1",
  d: "M.3,274.752a9.818,9.818,0,0,1,2.732-6.6,9.157,9.157,0,0,1,6.6-2.754,9.157,9.157,0,0,1,6.6,2.754,9.819,9.819,0,0,1,2.733,6.6Zm0,0",
  transform: "translate(0 -251.067)"
}));
function SvgLoginUsernameIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.674,
    height: 23.685,
    viewBox: "0 0 18.674 23.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginUsernameIcon);
export default __webpack_public_path__ + "static/media/login-username-icon.c893fc9e7bdf7847680b190e5fc71250.svg";
export { ForwardRef as ReactComponent };